import Bigs from '@features/Bigs/ui/Bigs';

export default function BigsPage() {
  return <Bigs />;
}
